import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { setUserProjectsFilterType, userProjectListSelector } from 'src/features'

const ProjectFilterVintages: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { filterType } = useAppSelector(userProjectListSelector)

  const { width } = useWindowSize()
  const isMobile = width <= 800

  return (
    <Select
      value={filterType}
      onChange={(value) => dispatch(setUserProjectsFilterType(value))}
      style={{ width: isMobile ? '100%' : '90%' }}
      className={isMobile && 'mb-2'}
    >
      <Select.Option value={'ALL'}>{t('Projects.All')}</Select.Option>
      <Select.Option value={'VINTAGE'}>{t('Vintages')}</Select.Option>
      <Select.Option value={'NO_VINTAGE'}>{t('No Vintages')}</Select.Option>
    </ Select>
  )
}

export default ProjectFilterVintages
